import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChange,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { IDayTradesOrders } from '@models/day-trades.class';
import { Store } from '@ngrx/store';
import moment from 'moment-timezone';
import { filter, map } from 'rxjs/operators';
import { TRACKING_EVENTS } from 'src/app/app.constants';
import { AppState } from 'src/app/state/app-state';
import { SideModalComponent } from 'src/components/side-modal/side-modal.component';
import { MixpanelService } from 'src/core/services/mixpanel.service';
import { SearchService } from 'src/core/services/search.service';

@Component({
  selector: 'app-day-trade',
  templateUrl: './day-trade.component.html',
  styleUrls: ['./day-trade.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DayTradeComponent implements OnInit, OnChanges {
  @Input() dayTradesItems: IDayTradesOrders[];
  @Input() nextDate: string;

  @ViewChild('sideModal', { static: true }) sideModal: SideModalComponent;

  public nextDateLabel: string;
  public readonly DAY_TRADE_INFO: string =
    'Los day trades son la compra y venta de una emisora en un mismo día, en tu estrategia de Trading USA sólo lo puedes realizar durante 5 días hábiles';
  public itemsTemp: any = [{ ticker: '' }, { ticker: '' }, { ticker: '' }];
  public items: any = [];
  public dayTradesCount = 0;
  constructor(
    private searchService: SearchService,
    private store: Store<AppState>,
    private readonly mixpanelService: MixpanelService,
  ) {}

  ngOnInit() {
    this.store
      .select('initializers')
      .pipe(
        map((values: any) => values.toJS()),
        filter((values: any) => values.usaMarket === true),
      )
      .subscribe(() => {
        this.dayTradesItems && this.searchTickers();
        this.dayTradesCount = this.getDaytradesCompleted();
      });
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const { dayTradesItems } = changes;
    if (dayTradesItems && !dayTradesItems.firstChange) {
      this.searchTickers();
      this.dayTradesCount = this.getDaytradesCompleted();
    }
  }

  public handleOpenDayTradeInfo() {
    this.sideModal.showModal();

    this.mixpanelService.track(TRACKING_EVENTS.day_trades_info_click.event);
  }

  public handleCloseDayTradeInfo() {
    this.sideModal.handleHide();
  }

  private searchTickers() {
    this.items = [];
    this.dayTradesItems.forEach((item) => {
      const ticker = this.searchService.findDataBy(
        item.instrumentId,
        'instrumentId',
      );
      this.items.push({ ticker: ticker.issueID, isVirtual: item.isVirtual });
    });

    this.items = this.items.concat(this.itemsTemp);
    this.items.length = 3;
    this.nextDateLabel = moment(this.nextDate).format('LL');
  }

  private getDaytradesCompleted(): number {
    return this.dayTradesItems.filter((item) => {
      return !item.isVirtual;
    }).length;
  }
}
